import { defineComponent as d, computed as l, openBlock as c, createElementBlock as s, createElementVNode as t, toDisplayString as n, createCommentVNode as h, normalizeStyle as f, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "9022a500-cbd8-41c8-9b99-a5cc8d6e2d71" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), v = { mask: "url(#9022a500-cbd8-41c8-9b99-a5cc8d6e2d71)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#496e2d" d="M256 0h256v102.4L483.8 151l28.2 53.8v102.4l-30.5 50.7 30.5 51.7V512H0V409.6l34.7-51L0 307.1z"></path><path fill="#ff9811" d="M0 44.5v423V256z"></path><path fill="#ffda44" d="M231.7 102.4v102.4H512V102.4zM0 307.2v102.4h512V307.2H256l-128.2-26.4z"></path><path fill="#d80027" d="M256 307.2V0H0v307.2z"></path><path fill="#eee" d="m141.4 122.4 16.5 51h53.7L168 205l16.6 51-43.4-31.5L98 256l16.5-51L71 173.5h53.7z"></path>', 5), g = { fill: "none" }, V = ["r"], y = /* @__PURE__ */ d({
  __name: "tg",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), r = l(() => 256 + e.strokeWidth / 2);
    return (x, z) => (c(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      m,
      t("g", v, [
        e.flagName ? (c(), s("title", k, n(e.flagName), 1)) : h("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, V)
      ])
    ], 8, _));
  }
});
export {
  y as default
};
//# sourceMappingURL=tg-aeda0f85.js.map
